<template>
  <v-container id="form-container">
    <v-row class="mt-6">
      <v-col lg="12" md="12">
        <v-card class="pa-3">
          <v-row class="pa-6 align-center">
            <div style="font-size: 1.2em">
              Solicítale al cliente su
              <span style="color: #1d1d1f; font-weight: 500"
                >Número de usuario</span
              >
              y
              <span style="color: #1d1d1f; font-weight: 500"
                >Código de compra</span
              >
            </div>
            <v-spacer></v-spacer>
            <v-btn
              style="background: #1d1d1f; color: #fff"
              md
              class="font-weight-bold"
              @click="showRegister = true"
              >REGISTRAR CLIENTE</v-btn
            >
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <!-- <v-col cols="12">
    <RewardsComponent />
  </v-col> -->
      <RegisterComponent
        :visible="showRegister"
        @close="showRegister = null"
        @showDialogAlert="showDialogAlert"
      />
      <DialogAlert
        :visible="dialogAlert"
        :message="dialogAlertContent"
        @handleCloseDialogAlert="handleCloseDialogAlert"
      />

      <v-col cols="12" style="display: flex; justify-content: space-between">
        <v-btn
          style="background: #1d1d1f; color: #fff"
          md
          @click="$router.push({ name: 'reserved-credit-lines' })"
          class="font-weight-bold"
        >
          Nueva venta por Líneas Reservadas
          <a
            href="https://www.mangxo.com/help-center/suppliers"
            target="_blank"
            style="color: #fff !important"
          >
            <v-icon small class="ml-2" title="Haz clic y conoce como funciona."
              >mdi mdi-help-circle</v-icon
            >
          </a>
        </v-btn>
        <!-- <v-btn
          md
          @click="showWppPurchaseInfo = true"
          color="yellow amber white--text"
          class="font-weight-bold"
      >
        Nueva venta por Whatsapp
        <v-chip
          class="ma-2"
          color="white"
          text-color="yellow amber"
          small
        >
            <span style="color: #000 !important;">Nuevo</span>
            <v-icon right>
              mdi-star
            </v-icon>
        </v-chip>
      </v-btn> -->
      </v-col>
    </v-row>
    <v-row class="mt-6">
      <v-col lg="12" md="12">
        <v-card class="pa-6">
          <v-form v-model="valid">
            <v-row>
              <v-col cols="6 mt-4">
                <v-text-field
                  v-model="form.user_id"
                  label="Número de usuario"
                  :rules="[(v) => !!v || 'El campo es requerido']"
                  required
                  @keyup="searchCustomer"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-card class="pa-3 d-flex align-center" style="height: 80%">
                  <v-row v-if="loading == false && customer && msg == ''">
                    <v-col cols="6">
                      <h4>{{ customer.business_name }}</h4>
                      <h4>{{ customer.tax_id }}</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      class="d-flex text-center align-center violet"
                    >
                      <h4>
                        Crédito disponible {{ customer.available | currency }}
                      </h4>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading == false && msg != ''">
                    <v-col cols="12" class="text-center">
                      <h4>{{ msg }}</h4>
                      <!-- Mostrar razón de desautorización si existe -->
                      <div v-if="reason" class="red--text mt-1">
                        <p><b>Motivo:</b> {{ reason }}</p>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="loading == false && customer == null && msg == ''"
                  >
                    <v-col cols="12" class="text-center">
                      <h4>Datos del cliente</h4>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading">
                    <v-col cols="12" class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <vuetify-money
                  v-model="form.amount"
                  label="Monto solicitado"
                  placeholder="Monto solicitado"
                  valueWhenIsEmpty=""
                  v-bind:options="options"
                  :rules="[(v) => !!v || 'El campo es requerido']"
                  outlined
                />

                <div>
                  Asegúrate de que el <b>monto ingresado aquí</b> coincida con
                  el <b>monto de la factura</b> para garantizar la protección de
                  la compra.
                </div>
              </v-col>
            </v-row>
            <v-text-field
              v-model="form.term"
              label="Días"
              type="number"
              :rules="[(v) => !!v || 'El campo es requerido']"
              outlined
              class="mt-4"
            ></v-text-field>

            <v-text-field
              v-model="form.reference"
              label="Referencia"
              :rules="[(v) => !!v || 'El campo es requerido']"
              counter="255"
              outlined
            ></v-text-field>

            <!-- Selector de vendedores -->
            <v-autocomplete
              v-if="vendors && vendors.length > 0"
              :value="form.vendor_user_id"
              @input="updateVendorSelection"
              :items="vendors"
              item-text="name"
              item-value="id"
              label="Seleccionar vendedor"
              placeholder="Buscar vendedor por nombre o código"
              outlined
              clearable
              cache-items
              hide-no-data
              :filter="vendorFilter"
              :rules="vendorRules"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title
                    >{{ item.code }} - {{ item.name }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>
              <template v-slot:selection="{ item }">
                <span>{{ item.code }} - {{ item.name }}</span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-caption grey--text text--darken-1"
                    >
                      Selecciona un vendedor para esta venta
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>

            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-if="!form.is_wpp_purchase"
                  v-model="form.token"
                  label="Código de compra (Token)"
                  type="number"
                  :rules="[(v) => !!v || 'El campo es requerido']"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="6"
                class="d-flex align-center"
                v-if="$UserManager.showSelectFactoring()"
              >
                <v-switch v-model="form.is_factoring" style="display: inline">
                  <template v-slot:label>
                    <div class="">
                      <span
                        :class="
                          form.is_factoring == false
                            ? 'v-input--switch-custom-danger'
                            : 'v-input--switch-custom-success'
                        "
                        >Realizar venta por factoraje:
                        {{ form.is_factoring ? "Sí" : "No" }}</span
                      >
                    </div>
                  </template>
                </v-switch>
              </v-col>
            </v-row>

            <v-btn
              :disabled="!valid"
              class="black white--text"
              @click="$emit('handleConfirm', customer.business_name)"
              block
            >
              SOLICITAR
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <!-- <WppPurchaseInfo 
    :visible="showWppPurchaseInfo" 
    @close="showWppPurchaseInfo = false"
  /> -->
  </v-container>
</template>

<script>
import options from "@/config/money";
import CustomerService from "@/services/customerService";
// import WppPurchaseInfo from "@/components/frontdesk/WppPurchaseInfo.vue"
import RegisterComponent from "@/components/frontdesk/actions/RegisterComponent.vue";
import DialogAlert from "@/components/DialogAlert.vue";
import SupplierService from "@/services/supplierService";
// import RewardsComponent  from '@/components/frontdesk/RewardsComponent.vue'

export default {
  props: ["value"],

  components: {
    // WppPurchaseInfo,
    RegisterComponent,
    DialogAlert,
  },

  data: () => ({
    valid: false,
    customer: null,
    msg: "",
    loading: false,
    searchTimer: null,
    // showWppPurchaseInfo: false,
    is_wpp_purchase: false,
    showRegister: false,
    dialogAlertContent: {},
    dialogAlert: false,
    vendors: [],
    localStorageVendorKey: "mangxo_selected_vendor_user_id",
  }),

  mounted() {
    // TODO: save customer name to avoid reloads
    if (this.form.user_id) {
      this.searchCustomer();
    }

    this.loadVendors().then(() => {
      // Auto-populate vendor from localStorage if available after vendors are loaded
      const savedVendorId = localStorage.getItem(this.localStorageVendorKey);

      if (savedVendorId && this.vendors.length > 0) {
        // Convert saved ID to a number for proper comparison
        const savedVendorIdNumber = parseInt(savedVendorId);

        // Check if the saved ID exists in the current vendors list
        const vendorExists = this.vendors.some(
          (vendor) => vendor.id === savedVendorIdNumber
        );
        if (vendorExists) {
          this.form.vendor_user_id = savedVendorIdNumber;
        } else {
          localStorage.removeItem(this.localStorageVendorKey);
        }
      }
    });
  },

  methods: {
    updateStoredVendorId(vendorId) {
      if (vendorId) {
        localStorage.setItem(this.localStorageVendorKey, vendorId);
      } else {
        localStorage.removeItem(this.localStorageVendorKey);
      }
    },

    async loadVendors() {
      try {
        // Verificar si el proveedor puede seleccionar vendedores
        const canSelect = await SupplierService.canSelectVendor();

        if (!canSelect) {
          this.vendors = [];

          return;
        }

        // Get vendors from the supplier service
        const vendors = await SupplierService.getVendors();

        if (vendors && Array.isArray(vendors)) {
          this.vendors = vendors;

          // After loading vendors, restore the selected vendor from localStorage if available
          const savedVendorId = localStorage.getItem(
            this.localStorageVendorKey
          );
          if (savedVendorId) {
            const savedVendorIdNumber = parseInt(savedVendorId);
            // Check if the saved vendor ID exists in the loaded vendors array
            const vendorExists = this.vendors.some(
              (vendor) => vendor.id === savedVendorIdNumber
            );
            if (vendorExists) {
              this.form.vendor_user_id = savedVendorIdNumber;
            } else {
              // If the saved vendor doesn't exist in the current list, remove it
              localStorage.removeItem(this.localStorageVendorKey);
            }
          }
        } else {
          this.vendors = [];
        }
      } catch (error) {
        this.vendors = [];
      }
    },

    async searchCustomer() {
      this.customer = null;
      this.msg = "";

      clearTimeout(this.searchTimer);

      let search = this.form.user_id;

      if (search.length == 0) {
        return;
      }

      this.searchTimer = setTimeout(async () => {
        await this.getCustomer();
      }, 1000);
    },

    async getCustomer() {
      this.loading = true;

      const response = await CustomerService.getByUser(this.form.user_id);
      const result = await response.json();
      const status = response.status;

      if (status == 200) {
        this.msg = "";
        this.customer = result.data;
      }

      if (status == 404 || status == 500) {
        this.customer = null;
        this.msg = result.msg;
        this.reason = result.reason || null;
      }

      this.loading = false;
    },
    handleAction(actionName) {
      console.log(actionName);
      this.showAction = actionName;
    },

    showDialogAlert(data) {
      this.dialogAlertContent.title = "";
      this.dialogAlertContent.success = data.success;
      this.dialogAlertContent.text = data.msg;
      this.dialogAlert = true;
    },

    handleCloseDialogAlert() {
      this.dialogAlert = false;
      this.dialogAlertContent.title = "";
      this.dialogAlertContent.success = "";
      this.dialogAlertContent.text = "";
    },

    vendorFilter(item, queryText) {
      const name = item.name || "";
      const code = item.code || "";
      const searchText = queryText.toLowerCase();

      // Buscar coincidencia en cualquier parte del nombre o código
      return (
        name.toLowerCase().indexOf(searchText) > -1 ||
        code.toLowerCase().indexOf(searchText) > -1
      );
    },

    updateVendorSelection(vendorId) {
      // Create a copy of the form object to trigger reactivity properly
      const updatedForm = { ...this.form, vendor_user_id: vendorId };
      // Emit the input event to update the parent component's value
      this.$emit("input", updatedForm);
      // Save to localStorage
      this.updateStoredVendorId(vendorId);
    },
  },

  computed: {
    form: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    options: () => {
      return options;
    },
    vendorRules() {
      return this.vendors.length > 0
        ? [(v) => !!v || "El campo es requerido"]
        : [];
    },
  },

  filters: {
    currency(value) {
      var formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      });

      return formatter.format(value);
    },
  },
};
</script>

<style scoped>
@media (min-width: 1265px) {
  #form-container {
    width: 75%;
    margin: auto;
  }
}

@media (min-width: 1600px) {
  #form-container {
    /* width: 55%; */
    margin: auto;
  }
}

.v-input--switch-custom-danger {
  color: #bb0404 !important;
  font-weight: 600;
  font-size: 1em;
}

.v-input--switch-custom-success {
  color: #1f9f02 !important;
  font-weight: 600;
  font-size: 1em;
}

.v-input--switch__track {
  background-color: #ccc !important;
}

div.v-input--switch__thumb {
  background: #bb0404 !important;
}

div.v-input--switch__thumb.primary--text {
  background: #1f9f02 !important;
}
</style>
